{
  "loading": "Läser in...",
  "placeholder": "Välj ett alternativ..."
}
